import {Commander, ConnectedDevice, Lifecycle, PSDK} from '@psdk/frame-father'
import {
  CBar,
  CBox,
  CBold,
  CFeed,
  CForm,
  CImage,
  CInverse,
  CLine,
  CMag,
  CPageMode,
  CPage,
  CPrint,
  CQRCode,
  CText,
  CUnderLine,
  CWaterMark,
  CStatus,
  CSN
} from "../args";

import {CMode} from "../types";

export abstract class BasicCPCL<T extends BasicCPCL<any>> extends PSDK<T> {

  /**
   * lifecycle
   * @private
   */
  private _lifecycle: Lifecycle;
  /**
   * commander
   * @private
   */
  private _commander: Commander;

  protected constructor(lifecycle: Lifecycle) {
    super();
    this._lifecycle = lifecycle;
    this._commander = Commander.make();
  }

  connectedDevice(): ConnectedDevice {
    return this._lifecycle.connectedDevice;
  }

  commander(): Commander {
    return this._commander;
  }

  /**
   * 一维码
   */
  public bar(arg: CBar): T {
    return super.push(arg);
  }

  /**
   * 画矩形边框
   */
  public box(arg: CBox): T {
    return super.push(arg);
  }

  /**
   * 加粗
   * @param bold true 加粗 false 不加粗
   */
  public bold(bold: boolean): T {
    return super.push(new CBold({bold: bold}));
  }

  /**
   * 定位到标签(print指令之前调用)
   */
  public feed(arg: CFeed): T {
    return super.push(arg);
  }

  /**
   * 定位到标签(可以放在print指令之后调用)
   */
  public form(arg: CForm): T {
    return super.push(arg);
  }

  /**
   * 打印图片
   */
  public image(arg: CImage): T {
    return super.push(arg);
  }

  /**
   * 文字反白
   */
  public inverse(arg: CInverse): T {
    return super.push(arg);
  }

  /**
   * 画线(能画斜线)
   */
  public line(arg: CLine): T {
    return super.push(arg);
  }

  public mag(arg: CMag): T {
    return super.push(arg);
  }

  /**
   * 打印模式(是否定位)
   */
  public pageMode(arg: CPageMode): T {
    return super.push(arg);
  }

  /**
   * 创建打印页面大小
   */
  public page(arg: CPage): T {
    return super.push(arg);
  }

  /**
   * 打印
   */
  public print(arg?: CPrint): T {
    return super.push(arg ?? new CPrint({mode: CMode.NORMAL}));
  }

  /**
   * 打印二维码
   */
  public qrcode(arg: CQRCode): T {
    return super.push(arg);
  }

  /**
   * 打印文本
   */
  public text(arg: CText): T {
    return super.push(arg);
  }

  /**
   * 下划线
   *
   * @param underline true 画下划线 false 不画下划线
   */
  public underline(underline: boolean): T {
    return super.push(new CUnderLine({underline: underline}));
  }

  /**
   * 水印
   * @param arg
   */
  public waterMark(arg: CWaterMark): T {
    return super.push(arg);
  }

  /**
   * 查询打印机状态
   */
  public status(arg: CStatus): T {
    return super.push(arg);
  }

  /**
   * 查询打印机SN
   */
  public sn(arg: CSN): T {
    return super.push(arg);
  }
}
